import * as React from "react";
import FormFieldProps from "./FormFieldProps";
import { Omit } from "recompose";

interface FieldValidation {
    error?: string;
}

interface WithValidateOnChangeExternalProps<TField> extends FormFieldProps<TField> {
    validate?(value: string): string;
    onValidate?(value: string): void;
}

interface WithValidateOnChangeInjectedProps {
    validation: FieldValidation;
}

interface WithValidateOnChangeState {
    error: string;
}

const withValidateOnChange = (options: {} = {}) =>
    <TOriginalProps extends any, TFieldProp extends any>(
        Component: (React.ComponentType<TOriginalProps & FormFieldProps<TFieldProp> & WithValidateOnChangeInjectedProps>)
    ) => {
        type ResultProps = Omit<TOriginalProps, keyof WithValidateOnChangeInjectedProps> & WithValidateOnChangeExternalProps<TFieldProp>;
        return class WithValidateOnChange extends React.Component<ResultProps, WithValidateOnChangeState> {
            static displayName = `WithValidateOnChange(${Component.displayName || Component.name})`;

            constructor(props: ResultProps) {
                super(props);
                this.state = {
                    error: null
                };
            }

            handleChange = (fieldValue: any) => {
                const {validate, onValidate, onChange} = this.props;

                const value = fieldValue === "" ? null : fieldValue;
                if (validate) {
                    const result = validate(value);
                    this.setState({error: result});
                    if (onValidate) {
                        onValidate(result);
                    }
                }
                if (onChange) {
                    onChange(value);
                }
            }

            render(): JSX.Element {
                const validate = { validation: this.state};
                return (<Component onChange={this.handleChange} {...this.props} {...validate} />);
            }
        };
    };

export default withValidateOnChange;
export { WithValidateOnChangeInjectedProps,  WithValidateOnChangeExternalProps,  WithValidateOnChangeState, withValidateOnChange };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/withValidateOnChange.tsx